import type { ProjectSchema } from '@shape-construction/api/src/types';
import type { UserSchema } from '@shape-construction/api/src-global/types';

const toProductPath = (product: NonNullable<UserSchema['defaultProduct']>) => {
  return {
    change_tracker: 'control-center',
    channels: 'channels',
    data_book: 'data-book',
    issues: 'issues',
    shift_manager: 'shift-reports',
    weekly_work_planner: 'weekly-planner/plans',
  }[product];
};

export const defaultProjectPath = (
  projectId?: ProjectSchema['id'] | null,
  defaultProduct?: UserSchema['defaultProduct']
) => {
  if (!projectId) return '/my-projects';

  return `/projects/${projectId}/${toProductPath(defaultProduct ?? 'issues')}`;
};
